import {getToken, setToken, removeToken} from '@/utils/auth'
import { getByUsername, getInfo, refreshToken, logout, mobileLogin, getPerms } from '@/api/system/user'
import {getCompany, switchCompany} from '@/api/enterprise/enterprise'
import {resetRouter,asyncRoutes, constantRoutes } from '@/router'

const user = {
	namespaced: true,

	state: {
		avatar: '',
		info: {},
		company: {},
		status: '',
		token: getToken(),
		roles: [],
		routes: [],
		currentRoutes: {},
		setting: {
			skin: []
		}
	},

	mutations: {
		SET_TOKEN: (state, token) => {
			state.token = token
		},
		SET_SETTING: (state, setting) => {
			state.setting = setting
		},
		SET_STATUS: (state, status) => {
			state.status = status
		},
		SET_USER: (state, user) => {
			state.info = user
		},
		SET_COMPANY: (state, company) => {
			state.company = company
		},
		SET_AVATAR: (state, avatar) => {
			state.avatar = avatar
		},
		SET_ROLES: (state, roles) => {
			state.roles = roles
		},
		SET_ROUTERS: (state, routes) => {
			state.routes = constantRoutes.concat(routes)
		},
		SET_CURRENT_ROUTES: (state, routes) => {
			state.currentRoutes = routes
		}
	},

	actions: {
		// 用户名登录
		login({commit}, userInfo) {
			const {username, password} = userInfo
			return new Promise((resolve, reject) => {
				getByUsername(username.trim(), password).then(response => {
					const data = response.data
					commit('SET_TOKEN', data.result.token)
					setToken(data.result.token, data.result.expire)
					resolve()
				}).catch(error => {
					reject(error)
				})
			})
		},

		// 验证码登录
		mobileLogin({commit}, captcha) {
			const {phone, code} = captcha
			return new Promise((resolve, reject) => {
				mobileLogin(phone.trim(), code).then(response => {
					const data = response.data
					commit('SET_TOKEN', data.result.token)
					setToken(data.result.token, data.result.expire)
					resolve()
				}).catch(error => {
					reject(error)
				})
			})
		},

		// 获取用户信息
		getInfo({commit}) {
			return new Promise((resolve, reject) => {
				getInfo().then(response => {
					const data = response.data.result
					commit('SET_ROLES', data.roles)
					commit('SET_USER', data.user)
					commit('SET_AVATAR', data.user.avatar)
					commit('SET_COMPANY', data.company)
					let accessedRoutes = buildRoutes(data.roles,data.perms)
					commit('SET_ROUTERS', accessedRoutes)

					resolve(data)
				}).catch(error => {
					reject(error)
				})
			})
		},

		// 获取公司信息
		getCompany({commit, state}) {
			return new Promise((resolve, reject) => {
				getCompany().then(response => {
					const comp = response.data.result
					commit('SET_COMPANY', comp)
					resolve(comp)
				}).catch(error => {
					reject(error)
				})
			})

		},

		// 获取公司信息
		switchCompany({commit, state}, company) {
			switchCompany(company.id).then(res => {
				const data = res.data.result
				if (data) {
					commit('SET_COMPANY', data)
				} else {
					console.log('切换企业失败！', res)
				}
			})
		},

		// 登出
		logout({dispatch, commit, state}) {
			dispatch('clearToken')
			return new Promise((resolve, reject) => {
				logout(state.token).then(() => {
					resolve()
				}).catch(error => {
					reject(error)
				})
			})
		},


		//获取动态路由
		generateRoutes({ commit }, roles) {
			return new Promise((resolve, reject) => {
				getPerms().then(response => {
					commit('SET_ROUTERS', [])
					let perms = response.data.result || {}
					let accessedRoutes = buildRoutes(roles,perms)
					commit('SET_ROUTERS', accessedRoutes)
					resolve(accessedRoutes)
				}).catch(error => {
						reject(error)
				})
			})
		},

		//前端退出，清除token
		refreshToken({commit}) {
			return new Promise((resolve,reject) => {
				refreshToken().then(response => {
					const data = response.data
					commit('SET_TOKEN', data.result.token)
					setToken(data.result.token, data.result.expire)
					resolve()
				}).catch(error => {
					reject(error)
				})
			})
		},
		//前端退出，清除token
		clearToken({commit}) {
			return new Promise(resolve => {
				commit('SET_TOKEN', '')
				commit('SET_ROLES', [])
				commit('SET_USER', null)
				commit('SET_COMPANY', null)
				removeToken()
				resolve()
			})
		},

		// 动态修改权限
		changeRoles({dispatch}) {
			dispatch('getInfo').then(resp =>{
				resetRouter()
				dispatch('generateRoutes', resp.roles || [])
			})
		}
	}
}

/**
 * 通过permission,构建路由
 *
 * @param roles
 * @param perms
 * @returns {any}
 */
function buildRoutes(roles,perms) {
	let accessedRoutes = []
	if (roles.includes('root')) {
		accessedRoutes = asyncRoutes || []
	} else {
		accessedRoutes = filterAsyncRoutes(asyncRoutes, perms||[])
	}

	return accessedRoutes;
}

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param routes
 * @param userRoutes {'sys-user':[*]}
 */
function hasPermission(routes, userRoute) {
	if(routes.meta && routes.meta.hasOwnProperty('auth') && routes.meta.auth === false){		//不需要权限判断的菜单
		return true
	}

	let keys = Object.keys(userRoute) //获取所有用户权限（后台分配）的key
	if (routes.name && keys.includes(routes.name)) {
		return true
	} else {
		return false
	}
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param allRoutes
 * @param userRoute
 */
function filterAsyncRoutes(allRoutes, userRoute) {
	let realRoutes = []

	allRoutes.forEach(route => {
		const tmp = { ...route }
		if (tmp.children && tmp.children.length > 0){
			tmp.children = filterAsyncRoutes(tmp.children, userRoute)
		}

		if (tmp.children && tmp.children.length > 0){
			realRoutes.push(tmp)
		}else if (hasPermission(tmp, userRoute)) {
			realRoutes.push(tmp)
		}
	})

	return realRoutes
}

export default user
